import { render, staticRenderFns } from "./CustomerCheckout.vue?vue&type=template&id=5a7b0a24&"
import script from "./customerCheckout.js?vue&type=script&lang=js&"
export * from "./customerCheckout.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports